import * as yup from 'yup'
import { yupResolver } from '@hookform/resolvers/yup'

export const editDetailedSummaryPeopleModalSchema = yupResolver(
  yup.object({
    amount: yup
      .string()
      .required('Valor é obrigatório')
  })
)
